import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {deepClone, ScreenService} from '@app/core';

@Component({
  selector: 'app-pocket-searchbar',
  standalone: false,

  templateUrl: './pocket-searchbar.component.html',
  styleUrl: './pocket-searchbar.component.less'
})
export class PocketSearchbarComponent {

  @Input() searchValue: string = '';
  @Output() searchValueChange = new EventEmitter<string>();

  @Output() searchEvent = new EventEmitter<void>();

  @Input()
  set hideInput(value: boolean) {
    if (value) {
      this.clear();
    }
  }

  @Output() showInputEvent = new EventEmitter<true>();

  @ViewChild('searchInput') searchInput!: ElementRef;

  showInput: boolean = false;

  isJustClear: boolean = false;

  constructor(
    public screenService: ScreenService
  ) {

  }

  search(value: string = this.searchValue) {
    this.searchValue = value;
    this.searchValueChange.emit(this.searchValue);
    this.searchEvent.emit();
  }

  clear() {
    this.searchValue = '';
    this.searchValueChange.emit(this.searchValue);
    this.search();
  }

  clearAndCollapse() {
    this.searchValue = '';
    this.searchValueChange.emit(this.searchValue);
    this.showInput = false;
    this.search();
  }

  toggleShowInput() {
    this.showInput = !this.showInput;
    if (!this.showInput) {
      this.clearAndCollapse();
    } else {
      this.showInputEvent.emit(true);
      // Enfoca el input después de que la vista se actualice
      setTimeout(() => {
        if (this.searchInput?.nativeElement) {
          this.searchInput.nativeElement.focus();
        }
      }, 0);
    }
  }

  onInputBlur() {
    const value = deepClone(this.searchValue)
    // Colapsar el buscador al quitar el foco del input
    setTimeout(() => {
      if (!this.isJustClear) {
        if (!value) this.showInput = false;
      } else {
        this.clear();
        this.searchInput.nativeElement.focus()
      }
      this.isJustClear = false;
    }, 100)
  }

  onEscapeKey() {
    // Al pulsar Esc, limpiar el contenido y quitar el foco del input
    if (this.searchInput?.nativeElement) {
      this.searchInput.nativeElement.blur();
    }
  }

}
